import React from "react";

export type CacheContextValue = {
  cacheId: string | null;
  restoreCacheId: () => void;
};

const CacheContext = React.createContext<CacheContextValue>({
  cacheId: null,
  restoreCacheId: () => {},
});

export default CacheContext;
